import { render, staticRenderFns } from "./navBarNoLab.vue?vue&type=template&id=23fba38e&scoped=true"
import script from "./navBarNoLab.vue?vue&type=script&lang=js"
export * from "./navBarNoLab.vue?vue&type=script&lang=js"
import style0 from "./navBarNoLab.vue?vue&type=style&index=0&id=23fba38e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fba38e",
  null
  
)

export default component.exports